import { useFetchTeamMembers } from '___queries/team'

export const useTeam = () => {
  const teamMembers = useFetchTeamMembers()
  return { members: teamMembers }
}

export default useTeam
